module.exports = __webpack_public_path__ + "img/電気回路_3_3_4.6d6fa762.png";